import HeaderInner from "../comp/head-navs-inner";
import ViewContentSmall from "../comp/view-content-sm";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import TeamCredsLinkModule from "../comp/team-cred-link";

export default function TeamLink() {

  return (
    <>
      <HeaderInner name={'New Student'} link={'/bz/team'}/>
      <ViewContentSmall 
        content={
          <>
            <ViewDividerSmall />
            <TeamCredsLinkModule />

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
    </>
  )
}